import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Heading,
  Text,
  useToast,
  Container,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Alert,
  AlertIcon,
  FormErrorMessage,
} from '@chakra-ui/react';
import { FullModelForm } from '../components/cricket/FullModelForm';
import { NextBallOutcomeForm } from '../components/cricket/NextBallOutcomeForm';
import { TtMarketsForm } from '../components/tabletennis/TtMarketsForm';

// Password for accessing the modeling page (Base64 encoded)
const ENCRYPTED_PASSWORD = 'TTBkM2wxbmdfVDAwbHMjMjAyNg==';

const decryptPassword = (encrypted: string): string => {
  try {
    return atob(encrypted);
  } catch {
    return '';
  }
};

export const ModelingPage: React.FC = () => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isError, setIsError] = useState(false);
  const toast = useToast();

  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const correctPassword = decryptPassword(ENCRYPTED_PASSWORD);
    
    if (password === correctPassword) {
      setIsAuthenticated(true);
      setIsError(false);
      toast({
        title: 'Access granted',
        description: 'Welcome to the Modeling Tools page',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } else {
      setIsError(true);
      toast({
        title: 'Access denied',
        description: 'Incorrect password',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (!isAuthenticated) {
    return (
      <Container maxW="md" py={10}>
        <VStack spacing={6} align="stretch">
          <Heading as="h1" size="xl" textAlign="center">
            Modeling Tools
          </Heading>
          <Text textAlign="center">
            This page requires a password to access the modeling tools.
          </Text>
          
          <Box as="form" onSubmit={handlePasswordSubmit}>
            <VStack spacing={4}>
              <FormControl isInvalid={isError}>
                <FormLabel>Password</FormLabel>
                <Input 
                  type="password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                />
                {isError && (
                  <FormErrorMessage>Incorrect password</FormErrorMessage>
                )}
              </FormControl>
              <Button type="submit" colorScheme="blue" width="full">
                Access Modeling Tools
              </Button>
            </VStack>
          </Box>
        </VStack>
      </Container>
    );
  }

  return (
    <Box p={4}>
      <Heading as="h1" size="xl" mb={6}>
        Modeling Tools
      </Heading>

      <Tabs variant="solid-rounded" colorScheme="blue" mb={4}>
        <TabList>
          <Tab>Cricket</Tab>
          <Tab>Table Tennis</Tab>
        </TabList>

        <TabPanels>
          <TabPanel px={0}>
            <Tabs variant="enclosed" colorScheme="blue">
              <TabList>
                <Tab>Full Model</Tab>
                <Tab>Next Ball Outcome</Tab>
              </TabList>

              <TabPanels>
                <TabPanel>
                  <FullModelForm />
                </TabPanel>
                <TabPanel>
                  <NextBallOutcomeForm />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </TabPanel>

          <TabPanel px={0}>
            <TtMarketsForm />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
